import { CargoType, CarrierVisitStatus, VesselVisitDto, VesselVisitsApi } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'
import { Event, IEvent, IQueryHandler, IQueryMessage } from '@tom-ui/utils'
import dayjs from 'dayjs'

export class GetVesselVisitsQuery implements IQueryMessage {
  static readonly type = 'GetVesselVisitsQuery'
  type = GetVesselVisitsQuery.type

  constructor(
    public from?: Date,
    public to?: Date,
    public includeCompleted = true,
    public orderBy = 'eta',
    public isDescending = false,
    public filter?: string,
    public status?: CarrierVisitStatus,
    public cargoType?: CargoType,
    public includeCancelled = false,
  ) {}

  getKey = () => JSON.stringify(this)
}

const httpClient = createApiClient(VesselVisitsApi)

export const getVesselVisitsQueryHandler: IQueryHandler<
  GetVesselVisitsQuery,
  IEvent<VesselVisitDto[]>
> = async query => {
  const { data } = await httpClient.get(
    1,
    10000,
    query.status,
    query.cargoType,
    query.includeCancelled,
    query.filter,
    query.includeCompleted,
    query.orderBy,
    query.isDescending,
    query.from ? dayjs(query.from).toISOString() : undefined,
    query.to ? dayjs(query.to).toISOString() : undefined,
  )

  return new Event(GetVesselVisitsQuery.type, data.payload)
}
